import { createSlice } from '@reduxjs/toolkit';

const getInitialState = () => ({
  form: {
    query: '',
    mode: 'wipoName',
    mktu: [],
    quantity: 20,
  },
  lastSearchQuery: '',
});

const initialState = getInitialState();

const wipoSlice = createSlice({
  name: 'wipo',
  initialState,
  reducers: {
    setWipoFormValues: (state, action) => {
      state.form = { ...state.form, ...action.payload };
    },
    setWipoLastSearchQuery: (state, action) => {
      state.lastSearchQuery = action.payload;
    },
  },
});

export const {
  setWipoFormValues,
  setWipoLastSearchQuery,
} = wipoSlice.actions;

export default wipoSlice.reducer;
